import { render, staticRenderFns } from "./test-tips.vue?vue&type=template&id=5e77345e&scoped=true&"
import script from "./test-tips.vue?vue&type=script&lang=js&"
export * from "./test-tips.vue?vue&type=script&lang=js&"
import style0 from "./test-tips.vue?vue&type=style&index=0&id=5e77345e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77345e",
  null
  
)

export default component.exports